import { HelpLayer } from "./help-layer/HelpLayer";
import { SettingsLayer } from "./settings-layer/SettingsLayer";
import { GameTitle } from "./GameTitle";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { AudioManager } from "../AudioManager";
import { GameManager } from "../GameManager";

export class SplashState extends Phaser.State {

    public static currentInstance: SplashState = null;

    public helpLayer: HelpLayer;
    public settingsLayer: SettingsLayer;

    private gameTitle: GameTitle;
    private fadingLayer: Phaser.Image;
    
    public init(): void {

        SplashState.currentInstance = this;

        this.settingsLayer = null;
        this.helpLayer = null;
    }

    public create(): void {

        // this.leavingScene = false;
        const backgroundImage = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "background_splash");
        backgroundImage.anchor.set(.5);
        backgroundImage.scale.y = GameVars.scaleY;

        this.gameTitle = new GameTitle(this.game);
        this.add.existing(this.gameTitle);

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
            const moreGamesButton = this.add.button(GameConstants.GAME_WIDTH - 50, 50, "texture_atlas_1", this.onClickMoreGames, this);
            moreGamesButton.setFrames("logo-lagged-on.png", "logo-lagged.png", "logo-lagged-on.png", "logo-lagged.png");
            moreGamesButton.anchor.set(1, 0);
            moreGamesButton.scale.set(.6, .6 * GameVars.scaleY);
            this.add.existing(moreGamesButton);
        }

        const midButtonsContainer = this.add.group();
        midButtonsContainer.x = GameConstants.GAME_WIDTH / 2;
        midButtonsContainer.y = 490;
        midButtonsContainer.scale.y = GameVars.scaleY;

        const buttonVSComputer = new Phaser.Button(this.game, 0, 120, "texture_atlas_2_" + GameVars.language, this.onClickVSComputer, this);
        buttonVSComputer.setFrames("button_vs_computer_on.png", "button_vs_computer_off.png", "button_vs_computer_on.png");
        buttonVSComputer.forceOut = true;
        buttonVSComputer.anchor.set(.5);
        midButtonsContainer.add(buttonVSComputer);

        this.game.add.tween(buttonVSComputer.scale)
            .to({x: 1.1, y: 1.1}, 3000, Phaser.Easing.Cubic.InOut, true, 0, -1, true);

        // LOS BOTONES DE LOS PROBLEMAS
        const tabPuzzles = new Phaser.Image(this.game, -GameConstants.GAME_WIDTH / 2, 190, "texture_atlas_2_" + GameVars.language, "tab_puzzles.png");
        midButtonsContainer.add(tabPuzzles);
        
        const twoMovementsProblemsButton = new Phaser.Button(this.game, -175, 320, "texture_atlas_2_" + GameVars.language, this.onClickProblemsButton, this);
        twoMovementsProblemsButton.setFrames("button_2_moves_on.png", "button_2_moves_off.png", "button_2_moves_on.png", "button_2_moves_off.png");
        twoMovementsProblemsButton.forceOut = true;
        twoMovementsProblemsButton.anchor.set(.5);
        twoMovementsProblemsButton.name = GameConstants.TWO_MOVES_PROBLEMS;
        midButtonsContainer.add(twoMovementsProblemsButton);

        if (GameVars.gameData.solvedCount[0] !== 0) {
            const twoMovementsText = new Phaser.Text(this.game, -180, 360, GameVars.gameData.solvedCount[0] + "/219", { font: "28px Roboto Slab Bold", fill: "#1e7168"});
            twoMovementsText.anchor.set(.5, 0);
            midButtonsContainer.add(twoMovementsText);
        }

        const threeMovementsProblemsButton = new Phaser.Button(this.game, 0, 320, "texture_atlas_2_" + GameVars.language, this.onClickProblemsButton, this);
        threeMovementsProblemsButton.setFrames("button_3_moves_on.png", "button_3_moves_off.png", "button_3_moves_on.png", "button_3_moves_off.png");
        threeMovementsProblemsButton.forceOut = true;
        threeMovementsProblemsButton.anchor.set(.5);
        threeMovementsProblemsButton.name = GameConstants.THREE_MOVES_PROBLEMS;
        midButtonsContainer.add(threeMovementsProblemsButton); 

        if (GameVars.gameData.solvedCount[1] !== 0) {
            const threeMovementsText = new Phaser.Text(this.game, -5, 360, GameVars.gameData.solvedCount[1] + "/483", { font: "28px Roboto Slab Bold", fill: "#1e7168"});
            threeMovementsText.anchor.set(.5, 0);
            midButtonsContainer.add(threeMovementsText);
        }

        const fourMovementsProblemsButton = new Phaser.Button(this.game, 175, 320, "texture_atlas_2_" + GameVars.language, this.onClickProblemsButton, this);
        fourMovementsProblemsButton.setFrames("button_4_moves_on.png", "button_4_moves_off.png", "button_4_moves_on.png", "button_4_moves_off.png");
        fourMovementsProblemsButton.forceOut = true;
        fourMovementsProblemsButton.anchor.set(.5);
        fourMovementsProblemsButton.name = GameConstants.FOUR_MOVES_PROBLEMS;
        midButtonsContainer.add(fourMovementsProblemsButton); 

        if (GameVars.gameData.solvedCount[2] !== 0) {
            const fourMovementsText = new Phaser.Text(this.game, 170, 360, GameVars.gameData.solvedCount[2] + "/459", { font: "28px Roboto Slab Bold", fill: "#1e7168"});
            fourMovementsText.anchor.set(.5, 0);
            midButtonsContainer.add(fourMovementsText);
        }

        const lowerButtonsContainer = this.add.group();
        lowerButtonsContainer.x = GameConstants.GAME_WIDTH / 2;
        lowerButtonsContainer.y = 934;
        lowerButtonsContainer.scale.y = GameVars.scaleY;

        const buttonHelp = new Phaser.Button(this.game, -75, 0, "texture_atlas_2_" + GameVars.language, this.onClickHelp, this);
        buttonHelp.setFrames("button_help_on.png", "button_help_off.png", "button_help_on.png", "button_help_off.png");
        buttonHelp.forceOut = true;
        buttonHelp.anchor.set(.5);
        lowerButtonsContainer.add(buttonHelp);

        const buttonSettings = new Phaser.Button(this.game, 75, 0, "texture_atlas_2_" + GameVars.language, this.onClickSettings, this);
        buttonSettings.setFrames("button_settings_on.png", "button_settings_off.png", "button_settings_on.png",  "button_settings_off.png");
        buttonSettings.forceOut = true;
        buttonSettings.anchor.set(.5);
        lowerButtonsContainer.add(buttonSettings);

        // EL MARCO DE MADERA
        // top
        const topFrame = this.add.image(0, 0, "texture_atlas_1", "frame_top.png");
        
        // bottom
        const bottomFrame = this.add.image(0, GameConstants.GAME_HEIGHT, "texture_atlas_1", "frame_bottom.png");
        bottomFrame.anchor.y = 1;

        // left
        const leftFrame = this.add.image(0, topFrame.height, "texture_atlas_1", "frame_left.png");
        leftFrame.scale.y = (GameConstants.GAME_HEIGHT - topFrame.height - bottomFrame.height) / leftFrame.height;

        const rightFrame = this.add.image(GameConstants.GAME_WIDTH, topFrame.height, "texture_atlas_1", "frame_right.png");
        rightFrame.anchor.x = 1;
        rightFrame.scale.y = (GameConstants.GAME_HEIGHT - topFrame.height - bottomFrame.height) / rightFrame.height;

        this.fadingLayer = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "background_splash");
        this.fadingLayer.anchor.set(.5);
        this.fadingLayer.scale.y = GameVars.scaleY;

        this.game.add.tween(this.fadingLayer)
            .to( {alpha: 0}, 450, Phaser.Easing.Cubic.Out, true, 350)
            .onComplete.add(function(): void {
                this.fadingLayer.destroy();
                if (GameVars.firstTimeSplash) {
                    GameVars.firstTimeSplash = false;
                    this.gameTitle.startAnimation();
                }
            }, this);
        
        if (AudioManager.loopPlayingKey === null) {
            AudioManager.playSound("loop", true);
        }
    }

    public shutdown(): void {

        SplashState.currentInstance = null;

        super.shutdown();
    }

    public removeHelpLayer(): void {
        
        this.helpLayer.destroy();
        this.helpLayer = null;
    }

    public removeSettingsLayer(): void {

        this.settingsLayer.destroy();
        this.settingsLayer = null;
    }

    private onClickMoreGames(): void {

        let win: Window;

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
            win = window.open("https://lagged.com", "_blank"); 
        }

        win.focus();
    }

    private onClickProblemsButton(b: Phaser.Button): void {

        AudioManager.playSound("click"); 

        b.clearFrames();

        let m: number;

        switch (b.name) {
            case GameConstants.TWO_MOVES_PROBLEMS:
                m = 2;
                break;
            case GameConstants.THREE_MOVES_PROBLEMS:
                m = 3;
                break;
            case GameConstants.FOUR_MOVES_PROBLEMS:
                m = 4;
                break;
            default:
        }

        GameManager.enterProblemSelectionState(m);
    }

    private onClickVSComputer(): void {

        if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
            if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd();
                GameVars.typeAd = "Start";
            } else {
                GameManager.vsComputerGameChosen();
            }
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_POKI) {
            if (!AudioManager.isMuted) {
                AudioManager.forceMute();
            }
            PokiSDK.commercialBreak().then(
                () => {
                    if (!AudioManager.isMuted) {
                        AudioManager.forceUnmute();
                    }
                    GameVars.onAd = false;
                    this.game.paused = false;
                    GameManager.vsComputerGameChosen();
                }
            );
            GameVars.onAd = true;
            this.game.paused = true;
        } else {
            GameManager.vsComputerGameChosen();
        } 

        AudioManager.playSound("click"); 
    }

    private onClickHelp(): void {

        this.helpLayer = new HelpLayer(this.game);
        this.add.existing(this.helpLayer);

        AudioManager.playSound("click"); 
    }

    private onClickSettings(): void {

        this.settingsLayer = new SettingsLayer(this.game);
        this.add.existing(this.settingsLayer);

        AudioManager.playSound("click"); 
    }
}
